import { LOGIN_PAGE } from '../../constants/links'

const redirectTo = (path = LOGIN_PAGE) => window.location.assign(path)

export default redirectTo
